import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TextInput from '../../../components/TextInput';
import Button from '../../../components/Button';
import SecurityIcon from '@mui/icons-material/Security';
import { freeStyleConnect } from '../../../utils/api';
import SnackbarComponent from '../../../components/Snackbar';

const IntegrationSetupModal = ({ open, onClose, integrationType, user, refetchIntegrationStatus }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarData, setSnackbarData] = useState({
    message: '',
    severity: 'success',
  });

  const handleInputChange = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const isFormValid = () => {
    return formData.email && formData.password;
  };

  const handleConnect = async () => {
    try {
      await freeStyleConnect({
        userId: user?._id || user?.id,
        email: formData.email,
        password: formData.password,
      });
      setSnackbarData({
        message: 'Device connected successfully!',
        severity: 'success',
      });
      setOpenSnackbar(true);
      if (refetchIntegrationStatus) {
        await refetchIntegrationStatus();
      }
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (error) {
      setSnackbarData({
        message: error.response.data.message || 'Connection failed',
        severity: 'error',
      });
      setOpenSnackbar(true);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: '12px',
          padding: '8px',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 24px',
        }}
      >
        <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
          Connect {integrationType || 'Device'}
        </Typography>
        <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: '16px 24px' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <TextInput label="Email" value={formData.email} onChange={handleInputChange('email')} fullWidth />

          <TextInput
            label="Password"
            type="password"
            value={formData.password}
            onChange={handleInputChange('password')}
            fullWidth
          />

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'text.secondary', mt: 1 }}>
            <SecurityIcon fontSize="small" />
            <Typography variant="caption">Your credentials are encrypted and never stored by CAN Care.</Typography>
          </Box>

          <Button
            text="Connect Device"
            onClick={handleConnect}
            disabled={!isFormValid()}
            fullWidth
            style={{ marginTop: '16px' }}
          />
        </Box>
      </DialogContent>
      <SnackbarComponent
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
        message={snackbarData.message}
        severity={snackbarData.severity}
        autoHide={5000}
      />
    </Dialog>
  );
};

export default IntegrationSetupModal;
